import * as React from "react";
import { useTranslation } from "react-i18next";
import { SpecialBettingsParityEnum } from "../../enums";

interface Props {
  parity: string;
}

const ParityBetting: React.FC<Props> = ({ parity }) => {
  const { t } = useTranslation();

  return (
    <>
      {parity.includes(SpecialBettingsParityEnum.EVEN)
        ? t("panel.bettingPanel.even")
        : t("panel.bettingPanel.odd")}
    </>
  );
};

export default ParityBetting;
